import React, { useState, useEffect } from "react";
import { POST } from "lib/api";
import { API_RATING_SETRATING } from "lib/endpoints/rating";
import withLanguageContext from "lib/hocs/withLanguageContext";
import LangContext from "./langContext";
import StarRating from "react-star-ratings";
import RatingForm from "./ratingForm";
import { StyledRating, StyledNoOfRatings } from "./style";
import Modal from "lib/components/modal";
import {
  NO_OF_STARS,
  STAR_COLOR,
  STAR_DIMENSION,
  STAR_SPACING,
} from "./constants";

const Rating = (props) => {
  const {
    languageContext,
    type,
    objectId,
    currentRating,
    currentComment,
    updateRating,
    readOnly,
    noOfRatings,
    managerView,
  } = props;
  const [rating, setRating] = useState(currentRating || 0);
  const [ratingActive, setRatingActive] = useState(false);

  const changeRating = () => {
    if (!readOnly) setRatingActive(true);
  };

  const closeRatingForm = () => {
    setRatingActive(false);
  };

  const saveRating = async (newRating, comment) => {
    if (!comment) comment = "";

    await POST(
      `${API_RATING_SETRATING}?${new URLSearchParams({
        type,
        objectId,
        rating: newRating,
        comment,
        anonymous: false,
      })}`,
    );

    updateRating(newRating, comment, objectId);
    setRating(newRating);
    closeRatingForm();
  };

  useEffect(() => {
    setRating(currentRating);
  }, [currentRating]);

  return (
    <LangContext.Provider value={languageContext}>
      {noOfRatings > 0 && (
        <StyledRating className="flex" title={languageContext("addreview")}>
          {readOnly && noOfRatings > 0 && (
            <StarRating
              rating={rating}
              starRatedColor={STAR_COLOR}
              numberOfStars={NO_OF_STARS}
              name="rating"
              starDimension={STAR_DIMENSION}
              starSpacing={STAR_SPACING}
              isSelectable={!readOnly}
            />
          )}
          {!readOnly && !managerView && (
            <StarRating
              rating={rating}
              starRatedColor={STAR_COLOR}
              changeRating={changeRating}
              numberOfStars={NO_OF_STARS}
              name="rating"
              starDimension={STAR_DIMENSION}
              starSpacing={STAR_SPACING}
            />
          )}
          {managerView && (
            <StarRating
              rating={rating}
              starRatedColor={STAR_COLOR}
              numberOfStars={NO_OF_STARS}
              name="rating"
              starDimension={STAR_DIMENSION}
              starSpacing={STAR_SPACING}
              isSelectable={false}
            />
          )}
          {readOnly && noOfRatings > 0 && (
            <StyledNoOfRatings>&nbsp; ({noOfRatings})</StyledNoOfRatings>
          )}
        </StyledRating>
      )}
      {ratingActive && (
        <Modal.Movable
          initiallyOpen
          title={languageContext("rate")}
          dialogStyles={{ minWidth: "450px" }}
          afterClose={closeRatingForm}
        >
          <LangContext.Provider value={languageContext}>
            <RatingForm
              tempRating={rating}
              tempComment={currentComment}
              saveRating={saveRating}
              closeRatingForm={closeRatingForm}
            />
          </LangContext.Provider>
        </Modal.Movable>
      )}
    </LangContext.Provider>
  );
};

export default withLanguageContext(Rating, "Rating");
